<script setup lang="ts">
const props = defineProps<{
  content: string
  maxLength: number
  areEmojisExcluded?: boolean
}>()

const emit = defineEmits<(e: 'truncateContent', content: string) => void>()
const { t } = useI18n()
watch(
  () => props.content,
  () => {
    if (props.content.length > props.maxLength) {
      emit('truncateContent', props.content.slice(0, props.maxLength))
    }
  }
)
</script>

<template>
  <div class="text-sm text-muted-foreground" :class="{ 'text-red-600': content.length > maxLength }">
    {{ content.length }}/{{ maxLength }} {{ t('global.words.characters') }}
    <span v-if="areEmojisExcluded">- {{ t('ui.error.strings.unauthorizedEmoji') }}</span>
  </div>
</template>
